// extracted by mini-css-extract-plugin
export var entityChip = "_sh-0";
export var entityChipMissing = "_sh-1";